import React, { useContext } from 'react';
import { CaptionText, DropdownMenu } from '@paypalcorp/pp-react';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import styles from '../Configurator.module.less';
import { trackFieldChange, trackFieldFocus, trackFieldClosed } from '../../../lib/fpti';
import DebouncedTextInput from '../../../components/DebouncedTextInput';
import isMobile from '../../../util/isMobile';

export default function OrderConfigurator() {
  const FTPI_INTENT = 'Intent';
  const FTPI_CURRENCY = 'Currency:Orders';

  const {
    OrderConfigurator: { updateAmount },
    SdkConfigurator: {
      sdkSettings: { currency, intent },
      buyerCurrencyOptions,
      updateSdkSettings
    },
    code: { updateActiveCodeBlock },
    appSwitch
  } = useContext(IntegrationPageSectionContext);

  function onValueChange(event, key, ftpiIdentifier) {
    const newValue = event.target.value;
    trackFieldChange(ftpiIdentifier, newValue);
    updateSdkSettings(newValue, key);
  }

  return (
    <>
      {/* TODO: JS SDK can not support these settings ... remove conditional render when React SDK supports app switch */}
      {!(isMobile() && appSwitch) && (
        <div className={styles.configuration}>
          <div className={styles.configuration_item}>
            <CaptionText className={styles.configuration_text}>Intent</CaptionText>
            <DropdownMenu
              className={styles.configuration_dropdown}
              label="Intent"
              value={intent}
              options={[
                { label: 'CAPTURE', value: 'capture' },
                { label: 'AUTHORIZE', value: 'authorize' }
              ]}
              onClick={() => trackFieldFocus('Intent')}
              onChange={(e) => {
                const selectedIntent = e.target.value;
                onValueChange(e, 'intent', FTPI_INTENT);
                updateActiveCodeBlock({
                  key: 'captureOrder',
                  value: selectedIntent === 'capture'
                });
                updateActiveCodeBlock({
                  key: 'authorizeOrder',
                  value: selectedIntent === 'authorize'
                });
              }}
            />
          </div>
          {buyerCurrencyOptions && (
            <div className={styles.configuration_item}>
              <CaptionText className={styles.configuration_text}>Currency Code</CaptionText>
              <DropdownMenu
                label="Currency Code"
                className={styles.configuration_dropdown}
                options={buyerCurrencyOptions}
                value={currency}
                onClick={() => trackFieldFocus('Currency:Orders')}
                onChange={(e) => onValueChange(e, 'currency', FTPI_CURRENCY)}
                onClose={() => trackFieldClosed('Currency:Orders')}
              />
            </div>
          )}
          <div className={styles.configuration_item}>
            <CaptionText className={styles.configuration_text}>Amount</CaptionText>
            <DebouncedTextInput
              label="Amount"
              id={'text-input-order-amount'}
              className={styles.configuration_dropdown}
              initialValue={'100'}
              type="number"
              onClick={() => trackFieldFocus('Amount')}
              onChange={(value) => {
                trackFieldChange('Amount', value);
                updateAmount(value, 'value');
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}
